
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as QGpzLWpvZGEvdGltZXpvbmU from '@js-joda/timezone';
import * as QG1hcGxpYnJlL2dlb2pzb24tdnQ from '@maplibre/geojson-vt';
import * as QG1hcGxpYnJlL21hcGxpYnJlLWdsLXN0eWxlLXNwZWM from '@maplibre/maplibre-gl-style-spec';
import * as QG1hcGxpYnJlL3Z0LXBiZg from '@maplibre/vt-pbf';
import * as ZmZsYXRl from 'fflate';
import * as bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM from 'maplibre-compose/maplibre-gl/index.mjs';
import * as d2FzbTpqcy1zdHJpbmc from './maplibre-compose-project-demo-app-common.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QG1hcGxpYnJlL21hcGxpYnJlLWdsLXN0eWxlLXNwZWM_ = QG1hcGxpYnJlL21hcGxpYnJlLWdsLXN0eWxlLXNwZWM;
const _ref_QG1hcGxpYnJlL2dlb2pzb24tdnQ_ = QG1hcGxpYnJlL2dlb2pzb24tdnQ;
const _ref_QG1hcGxpYnJlL3Z0LXBiZg_ = QG1hcGxpYnJlL3Z0LXBiZg;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_QGpzLWpvZGEvdGltZXpvbmU_ = QGpzLWpvZGEvdGltZXpvbmU;
const _ref_ZmZsYXRl_ = ZmZsYXRl;
const _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_ = bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_2' : (f, trampoline) => getCachedJsObject(f, (p0, p1) => trampoline(f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.UNSIGNED_BYTE_$external_prop_getter' : (_this) => _this.UNSIGNED_BYTE,
    'org.khronos.webgl.RGBA_$external_prop_getter' : (_this) => _this.RGBA,
    'org.khronos.webgl.LINEAR_$external_prop_getter' : (_this) => _this.LINEAR,
    'org.khronos.webgl.TEXTURE_MAG_FILTER_$external_prop_getter' : (_this) => _this.TEXTURE_MAG_FILTER,
    'org.khronos.webgl.TEXTURE_MIN_FILTER_$external_prop_getter' : (_this) => _this.TEXTURE_MIN_FILTER,
    'org.khronos.webgl.TEXTURE_WRAP_S_$external_prop_getter' : (_this) => _this.TEXTURE_WRAP_S,
    'org.khronos.webgl.TEXTURE_WRAP_T_$external_prop_getter' : (_this) => _this.TEXTURE_WRAP_T,
    'org.khronos.webgl.TEXTURE_2D_$external_prop_getter' : (_this) => _this.TEXTURE_2D,
    'org.khronos.webgl.CLAMP_TO_EDGE_$external_prop_getter' : (_this) => _this.CLAMP_TO_EDGE,
    'org.khronos.webgl.FRAMEBUFFER_$external_prop_getter' : (_this) => _this.FRAMEBUFFER,
    'org.khronos.webgl.RENDERBUFFER_$external_prop_getter' : (_this) => _this.RENDERBUFFER,
    'org.khronos.webgl.COLOR_ATTACHMENT0_$external_prop_getter' : (_this) => _this.COLOR_ATTACHMENT0,
    'org.khronos.webgl.FRAMEBUFFER_COMPLETE_$external_prop_getter' : (_this) => _this.FRAMEBUFFER_COMPLETE,
    'org.khronos.webgl.Companion_$external_object_getInstance' : () => WebGLRenderingContext,
    'org.khronos.webgl.WebGLFramebuffer_$external_class_instanceof' : (x) => x instanceof WebGLFramebuffer,
    'org.khronos.webgl.WebGLFramebuffer_$external_class_get' : () => WebGLFramebuffer,
    'org.khronos.webgl.WebGLRenderbuffer_$external_class_instanceof' : (x) => x instanceof WebGLRenderbuffer,
    'org.khronos.webgl.WebGLRenderbuffer_$external_class_get' : () => WebGLRenderbuffer,
    'org.khronos.webgl.bindFramebuffer_$external_fun' : (_this, p0, p1) => _this.bindFramebuffer(p0, p1),
    'org.khronos.webgl.bindRenderbuffer_$external_fun' : (_this, p0, p1) => _this.bindRenderbuffer(p0, p1),
    'org.khronos.webgl.bindTexture_$external_fun' : (_this, p0, p1) => _this.bindTexture(p0, p1),
    'org.khronos.webgl.checkFramebufferStatus_$external_fun' : (_this, p0) => _this.checkFramebufferStatus(p0),
    'org.khronos.webgl.createFramebuffer_$external_fun' : (_this, ) => _this.createFramebuffer(),
    'org.khronos.webgl.createRenderbuffer_$external_fun' : (_this, ) => _this.createRenderbuffer(),
    'org.khronos.webgl.createTexture_$external_fun' : (_this, ) => _this.createTexture(),
    'org.khronos.webgl.deleteFramebuffer_$external_fun' : (_this, p0) => _this.deleteFramebuffer(p0),
    'org.khronos.webgl.deleteRenderbuffer_$external_fun' : (_this, p0) => _this.deleteRenderbuffer(p0),
    'org.khronos.webgl.deleteTexture_$external_fun' : (_this, p0) => _this.deleteTexture(p0),
    'org.khronos.webgl.framebufferRenderbuffer_$external_fun' : (_this, p0, p1, p2, p3) => _this.framebufferRenderbuffer(p0, p1, p2, p3),
    'org.khronos.webgl.framebufferTexture2D_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.framebufferTexture2D(p0, p1, p2, p3, p4),
    'org.khronos.webgl.renderbufferStorage_$external_fun' : (_this, p0, p1, p2, p3) => _this.renderbufferStorage(p0, p1, p2, p3),
    'org.khronos.webgl.texImage2D_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6, p7, p8) => _this.texImage2D(p0, p1, p2, p3, p4, p5, p6, p7, p8),
    'org.khronos.webgl.texParameteri_$external_fun' : (_this, p0, p1, p2) => _this.texParameteri(p0, p1, p2),
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'org.w3c.dom.hasAttribute_$external_fun' : (_this, p0) => _this.hasAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.innerWidth_$external_prop_getter' : (_this) => _this.innerWidth,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.removeListener_$external_fun' : (_this, p0) => _this.removeListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentElement_$external_prop_getter' : (_this) => _this.parentElement,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.nextSibling_$external_prop_getter' : (_this) => _this.nextSibling,
    'org.w3c.dom.textContent_$external_prop_getter' : (_this) => _this.textContent,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_getter' : (_this) => _this.innerText,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.firstElementChild_$external_prop_getter' : (_this) => _this.firstElementChild,
    'org.w3c.dom.lastElementChild_$external_prop_getter' : (_this) => _this.lastElementChild,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.right_$external_prop_getter' : (_this) => _this.right,
    'org.w3c.dom.bottom_$external_prop_getter' : (_this) => _this.bottom,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.nextElementSibling_$external_prop_getter' : (_this) => _this.nextElementSibling,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.currentNanoTimeWindowPerformance' : () => window.performance.now() * 1000000,
    'org.jetbrains.skiko.windowRequestAnimationFrame' : (callback) => window.requestAnimationFrame(callback),
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'org.jetbrains.skiko.wasm.patchWebGlContext' : (canvas) => {
        if (!canvas.getContext.webGlContextPatched) {
            var oldGetContext = canvas.getContext;
            canvas.getContext = function() {
                var gl = oldGetContext.apply(this, arguments);
                if (gl && !gl.webGlContextPatched) {
                    var oldGetSupportedExtensions = gl.getSupportedExtensions;
                    if (typeof oldGetSupportedExtensions === 'function') {
                        gl.getSupportedExtensions = function() {
                            var exts = oldGetSupportedExtensions.apply(this, arguments);
                            if (exts && exts.filter) {
                                return exts.filter(function(name) {
                                    return name !== 'WEBGL_debug_renderer_info' && name !== 'WEBGL_polygon_mode';
                                });
                            }
                            return exts;
                        };
                    }
                    var oldGetExtension = gl.getExtension;
                    if (typeof oldGetExtension === 'function') {
                        gl.getExtension = function(name) {
                            if (name === 'WEBGL_debug_renderer_info' || name === 'WEBGL_polygon_mode') {
                                return null;
                            }
                            return oldGetExtension.apply(this, arguments);
                        };
                    }
                    var oldGetParameter = gl.getParameter;
                    if (typeof oldGetParameter === 'function') {
                        gl.getParameter = function(pname) {
                            // 0x9245 = UNMASKED_VENDOR_WEBGL, 0x9246 = UNMASKED_RENDERER_WEBGL;
                            // both belong to WEBGL_debug_renderer_info, so hide them to avoid the INVALID_ENUM warning
                            if (pname === 0x9245 || pname === 0x9246) {
                                return "";
                            }
                            // 0x0C02 = READ_BUFFER;
                            // hide to avoid "The READ_BUFFER attachment is multisampled" warning in Firefox
                            if (pname === 0x0C02) {
                                var fbo = oldGetParameter.apply(this, [0x8CAA]); // 0x8CAA = READ_FRAMEBUFFER_BINDING
                                return fbo ? 0x8CE0 : 0x0405; // 0x8CE0 = COLOR_ATTACHMENT0, 0x0405 = BACK
                            }
                            return oldGetParameter.apply(this, arguments);
                        };
                    }
                    gl.webGlContextPatched = true;
                }
                return gl;
            };
            canvas.getContext.webGlContextPatched = true;
        }
    },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun_1' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun_1' : (_this, ) => _this.deref(),
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.events.abort_$external_fun' : (_this, ) => _this.abort(),
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.getSelectionRange' : (element) => {
            var selection = window.getSelection();
            if (selection == null) return null;
            var root = element.getRootNode();
            if (root == null) return null;

            if (typeof selection.getComposedRanges === 'function') {
                try {
                    // The modern standard approach
                    var composedRanges = selection.getComposedRanges({ shadowRoots: [root] });
                    if (composedRanges.length > 0) {
                        return composedRanges[0];
                    }
                    return null;
                } catch (e) {
                    // Fallback for early Safari 17 point-releases
                    var composedRanges = selection.getComposedRanges(root);
                    if (composedRanges.length > 0) {
                        return composedRanges[0];
                    }
                    return null;
                }
            }

            if (typeof root.getSelection === 'function') {
                var rootSelection = root.getSelection();
                if (rootSelection == null) return [0, 0];
                if (rootSelection.rangeCount > 0) {
                    return rootSelection.getRangeAt(0);
                }
                return null;
            }

            if (selection.rangeCount > 0) {
                return selection.getRangeAt(0);
            }
            return null;
        },
    'androidx.compose.ui.platform.computeSelectionOffset' : (container, offset) => {          
        // container.nodeType stands for textNodes                   
        if (container.nodeType == 3) return offset;
        var chars = 0;
        var n = Math.min(offset, container.childNodes.length);
        for (var i = 0; i < n; i++) {
            var c = container.childNodes[i];
            chars += (c.nodeType == 3)
                ? c.nodeValue.length
                : ((c.textContent && c.textContent.length) || 0);
        }
        return chars;
        },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.firstRange_$external_prop_getter' : (_this) => _this.firstRange,
    'androidx.compose.ui.platform.firstRange_$external_prop_setter' : (_this, v) => _this.firstRange = v,
    'androidx.compose.ui.platform.getTargetRanges_$external_fun' : (_this, ) => _this.getTargetRanges(),
    'androidx.compose.ui.platform.startContainer_$external_prop_getter' : (_this) => _this.startContainer,
    'androidx.compose.ui.platform.startOffset_$external_prop_getter' : (_this) => _this.startOffset,
    'androidx.compose.ui.platform.endContainer_$external_prop_getter' : (_this) => _this.endContainer,
    'androidx.compose.ui.platform.endOffset_$external_prop_getter' : (_this) => _this.endOffset,
    'androidx.compose.ui.platform.collapsed_$external_prop_getter' : (_this) => _this.collapsed,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.setBaseAndExtent_$external_fun' : (_this, p0, p1, p2, p3) => _this.setBaseAndExtent(p0, p1, p2, p3),
    'androidx.compose.ui.platform.getSelection_$external_fun' : (_this, ) => _this.getSelection(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isSchedulerApiSupported' : () => Boolean('scheduler' in window),
    'androidx.compose.ui.platform.schedulerPostTask' : (block) => scheduler.postTask(block, { priority: 'user-blocking',}),
    'androidx.compose.ui.platform.isIdleApiSupported' : () => Boolean('requestIdleCallback' in window),
    'androidx.compose.ui.platform.requestIdleCallback' : (callback) => window.requestIdleCallback(callback),
    'androidx.compose.ui.platform.cancelIdleCallback' : (handle) => { window.cancelIdleCallback(handle) },
    'androidx.compose.ui.platform.timeRemaining_$external_fun' : (_this, ) => _this.timeRemaining(),
    'androidx.compose.ui.platform.didTimeout_$external_prop_getter' : (_this) => _this.didTimeout,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.hasVirtualKeyboard' : () => ('virtualKeyboard' in navigator),
    'androidx.compose.ui.platform.installSafeAreaCssProperties' : () => (function() {
            let s = document.documentElement.style;
            s.setProperty('--cmp-safe-top', 'env(safe-area-inset-top, 0px)');
            s.setProperty('--cmp-safe-right', 'env(safe-area-inset-right, 0px)');
            s.setProperty('--cmp-safe-bottom', 'env(safe-area-inset-bottom, 0px)');
            s.setProperty('--cmp-safe-left', 'env(safe-area-inset-left, 0px)');
        })(),
    'androidx.compose.ui.platform.enableVirtualKeyboardOverlay' : () => (navigator.virtualKeyboard.overlaysContent = true),
    'androidx.compose.ui.platform.getVirtualKeyboard' : () => navigator.virtualKeyboard,
    'androidx.compose.ui.platform.getVisualViewport' : () => (window.visualViewport || null),
    'androidx.compose.ui.platform.readCssVarLeft' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-left')) || 0),
    'androidx.compose.ui.platform.readCssVarTop' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-top')) || 0),
    'androidx.compose.ui.platform.readCssVarRight' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-right')) || 0),
    'androidx.compose.ui.platform.readCssVarBottom' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-bottom')) || 0),
    'androidx.compose.ui.platform.readVirtualKeyboardHeight' : () => (navigator.virtualKeyboard.boundingRect.height || 0),
    'androidx.compose.ui.platform.readVisualViewportImeHeight' : () => (function() {
        let vv = window.visualViewport;
        if (!vv) return 0;
        return Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    })(),
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                case 11: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/dialog_role
                    roleValue = "dialog";
                    break;
                case 12: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/link_role
                    roleValue = "link";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.toggleAttribute_$external_fun' : (_this, p0, p1) => _this.toggleAttribute(p0, p1),
    'androidx.compose.ui.platform.webgl.webGl2ContextOrNull' : (canvas) => canvas.getContext('webgl2'),
    'androidx.compose.ui.platform.webgl.unregisterTexture' : (gl, textureId) => (gl.textures[textureId] = null),
    'androidx.compose.ui.platform.webgl.pushTexture' : (gl, texture) => (function() {
            const textureHandle = gl.getNewId(gl.textures);
            gl.textures[textureHandle] = texture;
            return textureHandle;
        })(),
    'androidx.compose.ui.window.clearNodeChildren' : (node) => 
            {
                if (node.hasChildNodes()) node.replaceChildren();
            }
        ,
    'androidx.compose.ui.window.isWebGL2Supported' : () => !!document.createElement('canvas').getContext('webgl2'),
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.checkViewportFitCover' : () => (function() {
            let meta = document.querySelector('meta[name=viewport]');
            let content = meta ? (meta.getAttribute('content') || '') : '';
            if (!content.includes('viewport-fit=cover')) {
                console.warn(
                    "[ComposeWeb] enableBrowserWindowInsets is set to true, but " +
                    "'viewport-fit=cover' is not found in the viewport meta tag. " +
                    "Safe area insets will be zero. Add viewport-fit=cover to your viewport meta tag: " +
                    "<meta name=\"viewport\" content=\"width=device-width, initial-scale=1, viewport-fit=cover\">"
                );
            }
        })(),
    'androidx.compose.ui.window.getVisualViewportScale' : () => window.visualViewport.scale,
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.composeComponentElementCtor' : (weakMap) => 
        (() => {
            class ComposeComponentElement extends HTMLElement {
                disconnectedCallback() {
                    const cb = weakMap.get(this);
                    if (cb) cb();
                }
            }
            return ComposeComponentElement;
        })()
    ,
    'androidx.compose.ui.window.clientXOf' : (event) => event.clientX,
    'androidx.compose.ui.window.clientYOf' : (event) => event.clientY,
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.getVisualViewport' : () => window.visualViewport,
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.WeakMap_$external_fun' : () => new WeakMap(),
    'androidx.compose.ui.window.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.window.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'androidx.compose.ui.window.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.window.define_$external_fun' : (_this, p0, p1) => _this.define(p0, p1),
    'androidx.compose.ui.window.customElements_$external_prop_getter' : () => customElements,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'js.objects.unsafeJso' : () => ({}),
    'js.reflect.unsafeCast' : (value) => value,
    'js.array.jsArrayOf_$external_fun' : (p0) => Array.of(...p0),
    'js.date.Date_$external_fun' : (p0) => new Date(p0),
    'js.intl.NumberFormat_$external_fun' : (p0, p1, isDefault0, isDefault1) => new Intl.NumberFormat(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'js.intl.format_$external_fun' : (_this, p0) => _this.format(p0),
    'js.typedarrays.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'js.typedarrays.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'js.typedarrays.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'js.typedarrays.length_$external_prop_getter' : (_this) => _this.length,
    'js.typedarrays.Uint8Array_$external_fun_1' : (p0) => new Uint8Array(p0),
    'js.typedarrays.Uint8Array_$external_class_instanceof' : (x) => x instanceof Uint8Array,
    'js.typedarrays.Uint8Array_$external_class_get' : () => Uint8Array,
    'js.typedarrays.Uint8ClampedArray_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8ClampedArray(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'js.promise.then_$external_fun' : (_this, p0, p1) => _this.then(p0, p1),
    'js.typedarrays.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'web.blob.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'web.encoding.atob_$external_fun' : (p0) => atob(p0),
    'web.file.File_$external_fun' : (p0, p1, p2, isDefault0) => new File(p0, p1, isDefault0 ? undefined : p2, ),
    'web.images.ImageData_$external_fun' : (p0, p1, p2, p3, isDefault0, isDefault1) => new ImageData(p0, p1, isDefault0 ? undefined : p2, isDefault1 ? undefined : p3, ),
    'web.cssom.cssText_$external_prop_setter' : (_this, v) => _this.cssText = v,
    'web.cssom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'web.cssom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'web.cssom.style_$external_prop_getter' : (_this) => _this.style,
    'web.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'web.dom.body_$external_prop_getter' : (_this) => _this.body,
    'web.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'web.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'web.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'web.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'web.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'web.dom.document_$external_prop_getter' : () => document,
    'web.geolocation.clearWatch_$external_fun' : (_this, p0) => _this.clearWatch(p0),
    'web.geolocation.getCurrentPositionWithCallbacks_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.getCurrentPosition(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'web.geolocation.watchPositionWithCallbacks_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.watchPosition(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'web.geolocation.accuracy_$external_prop_getter' : (_this) => _this.accuracy,
    'web.geolocation.altitude_$external_prop_getter' : (_this) => _this.altitude,
    'web.geolocation.altitudeAccuracy_$external_prop_getter' : (_this) => _this.altitudeAccuracy,
    'web.geolocation.heading_$external_prop_getter' : (_this) => _this.heading,
    'web.geolocation.latitude_$external_prop_getter' : (_this) => _this.latitude,
    'web.geolocation.longitude_$external_prop_getter' : (_this) => _this.longitude,
    'web.geolocation.speed_$external_prop_getter' : (_this) => _this.speed,
    'web.geolocation.coords_$external_prop_getter' : (_this) => _this.coords,
    'web.geolocation.timestamp_$external_prop_getter' : (_this) => _this.timestamp,
    'web.geolocation.GeolocationPosition_$external_class_instanceof' : (x) => x instanceof GeolocationPosition,
    'web.geolocation.GeolocationPosition_$external_class_get' : () => GeolocationPosition,
    'web.geolocation.code_$external_prop_getter' : (_this) => _this.code,
    'web.geolocation.PERMISSION_DENIED_$external_prop_getter' : (_this) => _this.PERMISSION_DENIED,
    'web.geolocation.POSITION_UNAVAILABLE_$external_prop_getter' : (_this) => _this.POSITION_UNAVAILABLE,
    'web.geolocation.TIMEOUT_$external_prop_getter' : (_this) => _this.TIMEOUT,
    'web.geolocation.Companion_$external_object_getInstance' : () => GeolocationPositionError,
    'web.geolocation.GeolocationPositionError_$external_class_instanceof' : (x) => x instanceof GeolocationPositionError,
    'web.geolocation.GeolocationPositionError_$external_class_get' : () => GeolocationPositionError,
    'web.geolocation.enableHighAccuracy_$external_prop_setter' : (_this, v) => _this.enableHighAccuracy = v,
    'web.gl.WebGL2RenderingContext_$external_class_instanceof' : (x) => x instanceof WebGL2RenderingContext,
    'web.gl.WebGL2RenderingContext_$external_class_get' : () => WebGL2RenderingContext,
    'web.gl.disable_$external_fun' : (_this, p0) => _this.disable(p0),
    'web.html.download_$external_prop_setter' : (_this, v) => _this.download = v,
    'web.html.HTMLAnchorElement_$external_class_instanceof' : (x) => x instanceof HTMLAnchorElement,
    'web.html.HTMLAnchorElement_$external_class_get' : () => HTMLAnchorElement,
    'web.html.height_$external_prop_getter' : (_this) => _this.height,
    'web.html.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'web.html.width_$external_prop_getter' : (_this) => _this.width,
    'web.html.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'web.html.click_$external_fun' : (_this, ) => _this.click(),
    'web.html.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'web.html.HTMLElement_$external_class_get' : () => HTMLElement,
    'web.html.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'web.navigator.geolocation_$external_prop_getter' : (_this) => _this.geolocation,
    'web.navigator.permissions_$external_prop_getter' : (_this) => _this.permissions,
    'web.navigator.canShare_$external_fun' : (_this, p0, isDefault0) => _this.canShare(isDefault0 ? undefined : p0, ),
    'web.navigator.navigator_$external_prop_getter' : () => navigator,
    'web.permissions.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'web.permissions.Companion_$external_object_getInstance' : () => ({}),
    'web.permissions.Companion_$external_object_getInstance_1' : () => ({}),
    'web.permissions.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'web.permissions.state_$external_prop_getter' : (_this) => _this.state,
    'web.permissions.queryAsync_$external_fun' : (_this, p0) => _this.query(p0),
    'web.share.files_$external_prop_setter' : (_this, v) => _this.files = v,
    'org.maplibre.compose.location.supportsGeolocation' : () => navigator.geolocation != null,
    'org.maplibre.compose.location.supportsPermissions' : () => navigator.permissions != null && typeof navigator.permissions.query === 'function',
    'org.maplibre.compose.location.setPositionTimeout' : (options, timeout) => { options.timeout = timeout },
    'org.maplibre.compose.gljs.data_$external_prop_getter' : (_this) => _this.data,
    'org.maplibre.compose.gljs.pixelRatio_$external_prop_getter' : (_this) => _this.pixelRatio,
    'org.maplibre.compose.gljs.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.maplibre.compose.gljs.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.maplibre.compose.gljs.renderingMode_$external_prop_setter' : (_this, v) => _this.renderingMode = v,
    'org.maplibre.compose.gljs.onAdd_$external_prop_setter' : (_this, v) => _this.onAdd = v,
    'org.maplibre.compose.gljs.onRemove_$external_prop_setter' : (_this, v) => _this.onRemove = v,
    'org.maplibre.compose.gljs.render_$external_prop_setter' : (_this, v) => _this.render = v,
    'org.maplibre.compose.gljs.shaderData_$external_prop_getter' : (_this) => _this.shaderData,
    'org.maplibre.compose.gljs.defaultProjectionData_$external_prop_getter' : (_this) => _this.defaultProjectionData,
    'org.maplibre.compose.gljs.getProjectionData_$external_fun' : (_this, p0) => _this.getProjectionData(p0),
    'org.maplibre.compose.gljs.variantName_$external_prop_getter' : (_this) => _this.variantName,
    'org.maplibre.compose.gljs.vertexShaderPrelude_$external_prop_getter' : (_this) => _this.vertexShaderPrelude,
    'org.maplibre.compose.gljs.define_$external_prop_getter' : (_this) => _this.define,
    'org.maplibre.compose.gljs.mainMatrix_$external_prop_getter' : (_this) => _this.mainMatrix,
    'org.maplibre.compose.gljs.fallbackMatrix_$external_prop_getter' : (_this) => _this.fallbackMatrix,
    'org.maplibre.compose.gljs.tileMercatorCoords_$external_prop_getter' : (_this) => _this.tileMercatorCoords,
    'org.maplibre.compose.gljs.clippingPlane_$external_prop_getter' : (_this) => _this.clippingPlane,
    'org.maplibre.compose.gljs.projectionTransition_$external_prop_getter' : (_this) => _this.projectionTransition,
    'org.maplibre.compose.gljs.tileID_$external_prop_setter' : (_this, v) => _this.tileID = v,
    'org.maplibre.compose.gljs.applyGlobeMatrix_$external_prop_setter' : (_this, v) => _this.applyGlobeMatrix = v,
    'org.maplibre.compose.gljs.wrap_$external_prop_setter' : (_this, v) => _this.wrap = v,
    'org.maplibre.compose.gljs.canonical_$external_prop_setter' : (_this, v) => _this.canonical = v,
    'org.maplibre.compose.gljs.x_$external_prop_setter' : (_this, v) => _this.x = v,
    'org.maplibre.compose.gljs.y_$external_prop_setter' : (_this, v) => _this.y = v,
    'org.maplibre.compose.gljs.z_$external_prop_setter' : (_this, v) => _this.z = v,
    'org.maplibre.compose.gljs.failedRequestUrl' : (event) => event.error == null || event.error.url == null ? null : event.error.url,
    'org.maplibre.compose.gljs.failedTileId' : (event) => event.tile && event.tile.tileID && event.tile.tileID.canonical ? [event.tile.tileID.canonical.z,event.tile.tileID.canonical.x,event.tile.tileID.canonical.y].join('/') : null,
    'org.maplibre.compose.gljs.terminalStyleLoadFailure' : (event) => !!event.style && event.style._loaded !== true && event.style._loadStyleRequest == null && event.style._frameRequest == null,
    'org.maplibre.compose.gljs.setUint8At' : (target, index, value) => { target[index] = value },
    'org.maplibre.compose.gljs.jsPair' : (a, b) => [a, b],
    'org.maplibre.compose.gljs.glGetNumber' : (gl, pname) => typeof gl.getParameter(pname) === 'number' ? gl.getParameter(pname) : null,
    'org.maplibre.compose.gljs.eventLayerId' : (event) => event.layer == null ? null : event.layer.id,
    'org.maplibre.compose.gljs.jsUnsafeCast' : (value) => value,
    'org.maplibre.compose.gljs.jsPairAny' : (a, b) => [a, b],
    'org.maplibre.compose.gljs.jsStringToKotlin' : (value) => value,
    'org.maplibre.compose.gljs.jsGet' : (obj, name) => obj[name],
    'org.maplibre.compose.gljs.jsQuad' : (a, b, c, d) => [a, b, c, d],
    'org.maplibre.compose.gljs.jsNumberToDouble' : (value) => value,
    'org.maplibre.compose.gljs.jsSet' : (obj, name, value) => { obj[name] = value },
    'org.maplibre.compose.gljs.parseJson' : (text) => JSON.parse(text),
    'org.maplibre.compose.gljs.stringifyJson' : (value) => JSON.stringify(value),
    'org.maplibre.compose.gljs.isJsNullish' : (value) => value == null,
    'org.maplibre.compose.gljs.objectKeys' : (obj) => Object.keys(obj),
    'org.maplibre.compose.gljs.isJsFunction' : (value) => typeof value === 'function',
    'org.maplibre.compose.gljs.call0Boolean' : (receiver, name) => receiver[name](),
    'org.maplibre.compose.gljs.jsError' : (message) => new Error(message),
    'org.maplibre.compose.gljs.bindSamplerNone' : (gl, unit) => { gl.bindSampler(unit, null) },
    'org.maplibre.compose.gljs.glEnum' : (value) => value,
    'org.maplibre.compose.gljs.getDefaultWorkerUrl_$external_fun' : () => _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.getDefaultWorkerUrl(),
    'org.maplibre.compose.gljs.MaplibreMap_$external_fun' : (p0) => new _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.Map(p0),
    'org.maplibre.compose.gljs._camera_$external_prop_getter' : (_this) => _this._camera,
    'org.maplibre.compose.gljs.terrain_$external_prop_getter' : (_this) => _this.terrain,
    'org.maplibre.compose.gljs.painter_$external_prop_getter' : (_this) => _this.painter,
    'org.maplibre.compose.gljs.style_$external_prop_getter' : (_this) => _this.style,
    'org.maplibre.compose.gljs.showTileBoundaries_$external_prop_setter' : (_this, v) => _this.showTileBoundaries = v,
    'org.maplibre.compose.gljs.showCollisionBoxes_$external_prop_setter' : (_this, v) => _this.showCollisionBoxes = v,
    'org.maplibre.compose.gljs.showPadding_$external_prop_setter' : (_this, v) => _this.showPadding = v,
    'org.maplibre.compose.gljs.showOverdrawInspector_$external_prop_setter' : (_this, v) => _this.showOverdrawInspector = v,
    'org.maplibre.compose.gljs.on_$external_fun' : (_this, p0, p1) => _this.on(p0, p1),
    'org.maplibre.compose.gljs.getCanvas_$external_fun' : (_this, ) => _this.getCanvas(),
    'org.maplibre.compose.gljs.setPixelRatio_$external_fun' : (_this, p0) => _this.setPixelRatio(p0),
    'org.maplibre.compose.gljs.resize_$external_fun' : (_this, ) => _this.resize(),
    'org.maplibre.compose.gljs.triggerRepaint_$external_fun' : (_this, ) => _this.triggerRepaint(),
    'org.maplibre.compose.gljs.redraw_$external_fun' : (_this, ) => _this.redraw(),
    'org.maplibre.compose.gljs.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.maplibre.compose.gljs.setStyle_$external_fun' : (_this, p0, p1) => _this.setStyle(p0, p1),
    'org.maplibre.compose.gljs.isStyleLoaded_$external_fun' : (_this, ) => _this.isStyleLoaded(),
    'org.maplibre.compose.gljs.isSourceLoaded_$external_fun' : (_this, p0) => _this.isSourceLoaded(p0),
    'org.maplibre.compose.gljs.refreshTiles_$external_fun' : (_this, p0, p1) => _this.refreshTiles(p0, p1),
    'org.maplibre.compose.gljs.getRenderWorldCopies_$external_fun' : (_this, ) => _this.getRenderWorldCopies(),
    'org.maplibre.compose.gljs.getImage_$external_fun' : (_this, p0) => _this.getImage(p0),
    'org.maplibre.compose.gljs.getPadding_$external_fun' : (_this, ) => _this.getPadding(),
    'org.maplibre.compose.gljs.getCenter_$external_fun' : (_this, ) => _this.getCenter(),
    'org.maplibre.compose.gljs.getZoom_$external_fun' : (_this, ) => _this.getZoom(),
    'org.maplibre.compose.gljs.getBearing_$external_fun' : (_this, ) => _this.getBearing(),
    'org.maplibre.compose.gljs.getPitch_$external_fun' : (_this, ) => _this.getPitch(),
    'org.maplibre.compose.gljs.cameraForBounds_$external_fun' : (_this, p0, p1) => _this.cameraForBounds(p0, p1),
    'org.maplibre.compose.gljs.getBounds_$external_fun' : (_this, ) => _this.getBounds(),
    'org.maplibre.compose.gljs.getMaxBounds_$external_fun' : (_this, ) => _this.getMaxBounds(),
    'org.maplibre.compose.gljs.getMinZoom_$external_fun' : (_this, ) => _this.getMinZoom(),
    'org.maplibre.compose.gljs.getMaxZoom_$external_fun' : (_this, ) => _this.getMaxZoom(),
    'org.maplibre.compose.gljs.getMinPitch_$external_fun' : (_this, ) => _this.getMinPitch(),
    'org.maplibre.compose.gljs.getMaxPitch_$external_fun' : (_this, ) => _this.getMaxPitch(),
    'org.maplibre.compose.gljs.jumpTo_$external_fun' : (_this, p0) => _this.jumpTo(p0),
    'org.maplibre.compose.gljs.easeTo_$external_fun' : (_this, p0) => _this.easeTo(p0),
    'org.maplibre.compose.gljs.flyTo_$external_fun' : (_this, p0) => _this.flyTo(p0),
    'org.maplibre.compose.gljs.panBy_$external_fun' : (_this, p0, p1) => _this.panBy(p0, p1),
    'org.maplibre.compose.gljs.stop_$external_fun' : (_this, ) => _this.stop(),
    'org.maplibre.compose.gljs.setMaxBounds_$external_fun' : (_this, p0) => _this.setMaxBounds(p0),
    'org.maplibre.compose.gljs.setMinZoom_$external_fun' : (_this, p0) => _this.setMinZoom(p0),
    'org.maplibre.compose.gljs.setMaxZoom_$external_fun' : (_this, p0) => _this.setMaxZoom(p0),
    'org.maplibre.compose.gljs.setMinPitch_$external_fun' : (_this, p0) => _this.setMinPitch(p0),
    'org.maplibre.compose.gljs.setMaxPitch_$external_fun' : (_this, p0) => _this.setMaxPitch(p0),
    'org.maplibre.compose.gljs.setSourceTileLodParams_$external_fun' : (_this, p0, p1) => _this.setSourceTileLodParams(p0, p1),
    'org.maplibre.compose.gljs.project_$external_fun' : (_this, p0) => _this.project(p0),
    'org.maplibre.compose.gljs.unproject_$external_fun' : (_this, p0) => _this.unproject(p0),
    'org.maplibre.compose.gljs.queryRenderedFeatures_$external_fun' : (_this, p0, p1) => _this.queryRenderedFeatures(p0, p1),
    'org.maplibre.compose.gljs.setGlobalStateProperty_$external_fun' : (_this, p0, p1) => _this.setGlobalStateProperty(p0, p1),
    'org.maplibre.compose.gljs.getGlobalState_$external_fun' : (_this, ) => _this.getGlobalState(),
    'org.maplibre.compose.gljs.addSource_$external_fun' : (_this, p0, p1) => _this.addSource(p0, p1),
    'org.maplibre.compose.gljs.removeSource_$external_fun' : (_this, p0) => _this.removeSource(p0),
    'org.maplibre.compose.gljs.getSource_$external_fun' : (_this, p0) => _this.getSource(p0),
    'org.maplibre.compose.gljs.addLayer_$external_fun' : (_this, p0, p1, isDefault0) => _this.addLayer(p0, isDefault0 ? undefined : p1, ),
    'org.maplibre.compose.gljs.moveLayer_$external_fun' : (_this, p0, p1, isDefault0) => _this.moveLayer(p0, isDefault0 ? undefined : p1, ),
    'org.maplibre.compose.gljs.removeLayer_$external_fun' : (_this, p0) => _this.removeLayer(p0),
    'org.maplibre.compose.gljs.getLayer_$external_fun' : (_this, p0) => _this.getLayer(p0),
    'org.maplibre.compose.gljs.getLayersOrder_$external_fun' : (_this, ) => _this.getLayersOrder(),
    'org.maplibre.compose.gljs.setLayerZoomRange_$external_fun' : (_this, p0, p1, p2) => _this.setLayerZoomRange(p0, p1, p2),
    'org.maplibre.compose.gljs.setFilter_$external_fun' : (_this, p0, p1) => _this.setFilter(p0, p1),
    'org.maplibre.compose.gljs.setPaintProperty_$external_fun' : (_this, p0, p1, p2) => _this.setPaintProperty(p0, p1, p2),
    'org.maplibre.compose.gljs.setLayoutProperty_$external_fun' : (_this, p0, p1, p2) => _this.setLayoutProperty(p0, p1, p2),
    'org.maplibre.compose.gljs.addImage_$external_fun' : (_this, p0, p1, p2) => _this.addImage(p0, p1, p2),
    'org.maplibre.compose.gljs.hasImage_$external_fun' : (_this, p0) => _this.hasImage(p0),
    'org.maplibre.compose.gljs.removeImage_$external_fun' : (_this, p0) => _this.removeImage(p0),
    'org.maplibre.compose.gljs.setMissingStyleImageResolver_$external_fun' : (_this, p0) => _this.setMissingStyleImageResolver(p0),
    'org.maplibre.compose.gljs.MaplibreMap_$external_class_instanceof' : (x) => x instanceof _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.Map,
    'org.maplibre.compose.gljs.MaplibreMap_$external_class_get' : () => _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.Map,
    'org.maplibre.compose.gljs.addProtocol_$external_fun' : (p0, p1) => _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.addProtocol(p0, p1),
    'org.maplibre.compose.gljs.removeProtocol_$external_fun' : (p0) => _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.removeProtocol(p0),
    'org.maplibre.compose.gljs.LngLat_$external_fun' : (p0, p1) => new _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.LngLat(p0, p1),
    'org.maplibre.compose.gljs.lng_$external_prop_getter' : (_this) => _this.lng,
    'org.maplibre.compose.gljs.lat_$external_prop_getter' : (_this) => _this.lat,
    'org.maplibre.compose.gljs.LngLatBounds_$external_fun' : (p0, p1) => new _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.LngLatBounds(p0, p1),
    'org.maplibre.compose.gljs.getSouthWest_$external_fun' : (_this, ) => _this.getSouthWest(),
    'org.maplibre.compose.gljs.getNorthEast_$external_fun' : (_this, ) => _this.getNorthEast(),
    'org.maplibre.compose.gljs.tileManagers_$external_prop_getter' : (_this) => _this.tileManagers,
    'org.maplibre.compose.gljs.light_$external_prop_getter' : (_this) => _this.light,
    'org.maplibre.compose.gljs.sky_$external_prop_getter' : (_this) => _this.sky,
    'org.maplibre.compose.gljs.on_$external_fun_1' : (_this, p0, p1) => _this.on(p0, p1),
    'org.maplibre.compose.gljs.on_$external_fun_2' : (_this, p0, p1) => _this.on(p0, p1),
    'org.maplibre.compose.gljs.setWorkerUrl_$external_fun' : (p0) => _ref_bWFwbGlicmUtY29tcG9zZS9tYXBsaWJyZS1nbC9pbmRleC5tanM_.setWorkerUrl(p0),
    'org.maplibre.compose.gljs.sameOriginWorkerUrl' : (workerUrl) => 
          (function() {
            var loc = globalThis.location;
            if (!loc) return workerUrl;
            var resolvedWorkerUrl;
            try {
              resolvedWorkerUrl = new URL(workerUrl, loc.href);
              if (resolvedWorkerUrl.origin === loc.origin) return workerUrl;
            } catch (e) {
              return workerUrl;
            }
            return URL.createObjectURL(
              new Blob(
                ["import " + JSON.stringify(resolvedWorkerUrl.href)],
                {type: "text/javascript"}
              )
            );
          })()
          ,
    'org.maplibre.compose.gljs.newCanvasContextHook' : () => ({
        prototype: HTMLCanvasElement.prototype,
        original: HTMLCanvasElement.prototype.getContext,
        lent: 0
      }),
    'org.maplibre.compose.gljs.installCanvasContextHook' : (hook, gl) => {
          var original = hook.original;
          hook.prototype.getContext = function(type, options) {
            if (this !== gl.canvas && (type === 'webgl2' || type === 'webgl')) {
              hook.lent = hook.lent + 1;
              return gl;
            }
            return original.call(this, type, options);
          };
        },
    'org.maplibre.compose.gljs.restoreCanvasContextHook' : (hook) => {
          hook.prototype.getContext = hook.original;
          return hook.lent;
        },
    'org.maplibre.compose.gljs.defineDrawingBufferSize' : (gl, width, height) => {
          var objects = Object;
          var previousWidth = objects.getOwnPropertyDescriptor(gl, "drawingBufferWidth");
          var previousHeight = objects.getOwnPropertyDescriptor(gl, "drawingBufferHeight");
          objects.defineProperty(gl, "drawingBufferWidth", {configurable: true, value: width});
          objects.defineProperty(gl, "drawingBufferHeight", {configurable: true, value: height});
          return {
            objects: objects,
            gl: gl,
            previousWidth: previousWidth,
            previousHeight: previousHeight
          };
        },
    'org.maplibre.compose.gljs.restoreDrawingBufferSize' : (state) => {
          var objects = state.objects;
          var gl = state.gl;
          if (state.previousWidth == null) {
            Reflect.deleteProperty(gl, "drawingBufferWidth");
          } else {
            objects.defineProperty(gl, "drawingBufferWidth", state.previousWidth);
          }
          if (state.previousHeight == null) {
            Reflect.deleteProperty(gl, "drawingBufferHeight");
          } else {
            objects.defineProperty(gl, "drawingBufferHeight", state.previousHeight);
          }
        },
    'org.maplibre.compose.gljs.hasBindFramebufferSet' : (context) => !!context.bindFramebuffer && typeof context.bindFramebuffer.set === 'function',
    'org.maplibre.compose.gljs.installFramebufferRedirect' : (context, target) => {
          var binding = context.bindFramebuffer;
          binding.set = function(requested) {
            var next = (requested == null) ? target() : requested;
            if (next !== this.current || this.dirty === true) {
              this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, next);
              this.current = next;
              this.dirty = false;
            }
          };
        },
    'org.maplibre.compose.gljs.installLoseContextBlock' : (gl) => {
          var original = gl.getExtension.bind(gl);
          gl.getExtension = function(name) {
            if (name === 'WEBGL_lose_context') return null;
            return original(name);
          };
          return original;
        },
    'org.maplibre.compose.gljs.restoreGetExtension' : (gl, original) => { gl.getExtension = original; },
    'org.maplibre.compose.gljs.hasTriggerRepaint' : (map) => typeof map.triggerRepaint === 'function',
    'org.maplibre.compose.gljs.setTriggerRepaint' : (map, onRequest) => { map.triggerRepaint = onRequest; },
    'org.maplibre.compose.gljs.createPropertyExpression_$external_fun' : (p0, p1, p2) => _ref_QG1hcGxpYnJlL21hcGxpYnJlLWdsLXN0eWxlLXNwZWM_.createPropertyExpression(p0, p1, p2),
    'org.maplibre.compose.gljs.error_$external_prop_getter' : (_this) => _this.error,
    'org.maplibre.compose.gljs.sourceId_$external_prop_getter' : (_this) => _this.sourceId,
    'org.maplibre.compose.gljs.sourceDataType_$external_prop_getter' : (_this) => _this.sourceDataType,
    'org.maplibre.compose.gljs.width_$external_prop_getter' : (_this) => _this.width,
    'org.maplibre.compose.gljs.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.maplibre.compose.gljs.height_$external_prop_getter' : (_this) => _this.height,
    'org.maplibre.compose.gljs.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.maplibre.compose.gljs.data_$external_prop_getter_1' : (_this) => _this.data,
    'org.maplibre.compose.gljs.data_$external_prop_setter' : (_this, v) => _this.data = v,
    'org.maplibre.compose.gljs.message_$external_prop_getter' : (_this) => _this.message,
    'org.maplibre.compose.gljs.url_$external_prop_getter' : (_this) => _this.url,
    'org.maplibre.compose.gljs.url_$external_prop_setter' : (_this, v) => _this.url = v,
    'org.maplibre.compose.gljs.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'org.maplibre.compose.gljs.type_$external_prop_getter' : (_this) => _this.type,
    'org.maplibre.compose.gljs.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.maplibre.compose.gljs.data_$external_prop_setter_1' : (_this, v) => _this.data = v,
    'org.maplibre.compose.gljs.expires_$external_prop_setter' : (_this, v) => _this.expires = v,
    'org.maplibre.compose.gljs.aborted_$external_prop_getter' : (_this) => _this.aborted,
    'org.maplibre.compose.gljs.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.maplibre.compose.gljs.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.maplibre.compose.gljs.top_$external_prop_getter' : (_this) => _this.top,
    'org.maplibre.compose.gljs.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.maplibre.compose.gljs.bottom_$external_prop_getter' : (_this) => _this.bottom,
    'org.maplibre.compose.gljs.bottom_$external_prop_setter' : (_this, v) => _this.bottom = v,
    'org.maplibre.compose.gljs.left_$external_prop_getter' : (_this) => _this.left,
    'org.maplibre.compose.gljs.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.maplibre.compose.gljs.right_$external_prop_getter' : (_this) => _this.right,
    'org.maplibre.compose.gljs.right_$external_prop_setter' : (_this, v) => _this.right = v,
    'org.maplibre.compose.gljs.container_$external_prop_setter' : (_this, v) => _this.container = v,
    'org.maplibre.compose.gljs.interactive_$external_prop_setter' : (_this, v) => _this.interactive = v,
    'org.maplibre.compose.gljs.trackResize_$external_prop_setter' : (_this, v) => _this.trackResize = v,
    'org.maplibre.compose.gljs.attributionControl_$external_prop_setter' : (_this, v) => _this.attributionControl = v,
    'org.maplibre.compose.gljs.maplibreLogo_$external_prop_setter' : (_this, v) => _this.maplibreLogo = v,
    'org.maplibre.compose.gljs.pixelRatio_$external_prop_setter' : (_this, v) => _this.pixelRatio = v,
    'org.maplibre.compose.gljs.canvasContextAttributes_$external_prop_setter' : (_this, v) => _this.canvasContextAttributes = v,
    'org.maplibre.compose.gljs.maxCanvasSize_$external_prop_setter' : (_this, v) => _this.maxCanvasSize = v,
    'org.maplibre.compose.gljs.transformRequest_$external_prop_setter' : (_this, v) => _this.transformRequest = v,
    'org.maplibre.compose.gljs.preserveDrawingBuffer_$external_prop_setter' : (_this, v) => _this.preserveDrawingBuffer = v,
    'org.maplibre.compose.gljs.center_$external_prop_getter' : (_this) => _this.center,
    'org.maplibre.compose.gljs.centerPoint_$external_prop_getter' : (_this) => _this.centerPoint,
    'org.maplibre.compose.gljs.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.maplibre.compose.gljs.setCenter_$external_fun' : (_this, p0) => _this.setCenter(p0),
    'org.maplibre.compose.gljs.setZoom_$external_fun' : (_this, p0) => _this.setZoom(p0),
    'org.maplibre.compose.gljs.setBearing_$external_fun' : (_this, p0) => _this.setBearing(p0),
    'org.maplibre.compose.gljs.setPitch_$external_fun' : (_this, p0) => _this.setPitch(p0),
    'org.maplibre.compose.gljs.setPadding_$external_fun' : (_this, p0) => _this.setPadding(p0),
    'org.maplibre.compose.gljs.setLocationAtPoint_$external_fun' : (_this, p0, p1) => _this.setLocationAtPoint(p0, p1),
    'org.maplibre.compose.gljs.locationToScreenPoint_$external_fun' : (_this, p0, p1, isDefault0) => _this.locationToScreenPoint(p0, isDefault0 ? undefined : p1, ),
    'org.maplibre.compose.gljs.setDirty_$external_fun' : (_this, ) => _this.setDirty(),
    'org.maplibre.compose.gljs.context_$external_prop_getter' : (_this) => _this.context,
    'org.maplibre.compose.gljs.transform_$external_prop_getter' : (_this) => _this.transform,
    'org.maplibre.compose.gljs.x_$external_prop_getter' : (_this) => _this.x,
    'org.maplibre.compose.gljs.x_$external_prop_setter_1' : (_this, v) => _this.x = v,
    'org.maplibre.compose.gljs.y_$external_prop_getter' : (_this) => _this.y,
    'org.maplibre.compose.gljs.y_$external_prop_setter_1' : (_this, v) => _this.y = v,
    'org.maplibre.compose.gljs.around_$external_prop_setter' : (_this, v) => _this.around = v,
    'org.maplibre.compose.gljs.screenSpeed_$external_prop_setter' : (_this, v) => _this.screenSpeed = v,
    'org.maplibre.compose.gljs.minZoom_$external_prop_setter' : (_this, v) => _this.minZoom = v,
    'org.maplibre.compose.gljs.curve_$external_prop_setter' : (_this, v) => _this.curve = v,
    'org.maplibre.compose.gljs.maxDuration_$external_prop_setter' : (_this, v) => _this.maxDuration = v,
    'org.maplibre.compose.gljs.center_$external_prop_getter_1' : (_this) => _this.center,
    'org.maplibre.compose.gljs.zoom_$external_prop_getter' : (_this) => _this.zoom,
    'org.maplibre.compose.gljs.bearing_$external_prop_getter' : (_this) => _this.bearing,
    'org.maplibre.compose.gljs.pitch_$external_prop_getter' : (_this) => _this.pitch,
    'org.maplibre.compose.gljs.bearing_$external_prop_setter' : (_this, v) => _this.bearing = v,
    'org.maplibre.compose.gljs.pitch_$external_prop_setter' : (_this, v) => _this.pitch = v,
    'org.maplibre.compose.gljs.absolutePadding_$external_prop_setter' : (_this, v) => _this.absolutePadding = v,
    'org.maplibre.compose.gljs.padding_$external_prop_setter' : (_this, v) => _this.padding = v,
    'org.maplibre.compose.gljs.maxZoom_$external_prop_setter' : (_this, v) => _this.maxZoom = v,
    'org.maplibre.compose.gljs.id_$external_prop_getter' : (_this) => _this.id,
    'org.maplibre.compose.gljs.type_$external_prop_getter_1' : (_this) => _this.type,
    'org.maplibre.compose.gljs.source_$external_prop_getter' : (_this) => _this.source,
    'org.maplibre.compose.gljs.sourceLayer_$external_prop_getter' : (_this) => _this.sourceLayer,
    'org.maplibre.compose.gljs.minzoom_$external_prop_getter' : (_this) => _this.minzoom,
    'org.maplibre.compose.gljs.maxzoom_$external_prop_getter' : (_this) => _this.maxzoom,
    'org.maplibre.compose.gljs.serialize_$external_fun' : (_this, ) => _this.serialize(),
    'org.maplibre.compose.gljs.layers_$external_prop_setter' : (_this, v) => _this.layers = v,
    'org.maplibre.compose.gljs.filter_$external_prop_setter' : (_this, v) => _this.filter = v,
    'org.maplibre.compose.gljs.layer_$external_prop_getter' : (_this) => _this.layer,
    'org.maplibre.compose.gljs.id_$external_prop_getter_1' : (_this) => _this.id,
    'org.maplibre.compose.gljs.padding_$external_prop_setter_1' : (_this, v) => _this.padding = v,
    'org.maplibre.compose.gljs.unsubscribe_$external_fun' : (_this, ) => _this.unsubscribe(),
    'org.maplibre.compose.gljs.diff_$external_prop_setter' : (_this, v) => _this.diff = v,
    'org.maplibre.compose.gljs.x_$external_prop_setter_2' : (_this, v) => _this.x = v,
    'org.maplibre.compose.gljs.y_$external_prop_setter_2' : (_this, v) => _this.y = v,
    'org.maplibre.compose.gljs.z_$external_prop_setter_1' : (_this, v) => _this.z = v,
    'org.maplibre.compose.gljs.pixelRatio_$external_prop_setter_1' : (_this, v) => _this.pixelRatio = v,
    'org.maplibre.compose.gljs.sdf_$external_prop_setter' : (_this, v) => _this.sdf = v,
    'org.maplibre.compose.gljs.stretchX_$external_prop_setter' : (_this, v) => _this.stretchX = v,
    'org.maplibre.compose.gljs.stretchY_$external_prop_setter' : (_this, v) => _this.stretchY = v,
    'org.maplibre.compose.gljs.content_$external_prop_setter' : (_this, v) => _this.content = v,
    'org.maplibre.compose.gljs.duration_$external_prop_setter' : (_this, v) => _this.duration = v,
    'org.maplibre.compose.gljs.easing_$external_prop_setter' : (_this, v) => _this.easing = v,
    'org.maplibre.compose.gljs.center_$external_prop_setter' : (_this, v) => _this.center = v,
    'org.maplibre.compose.gljs.zoom_$external_prop_setter' : (_this, v) => _this.zoom = v,
    'org.maplibre.compose.gljs.bearing_$external_prop_setter_1' : (_this, v) => _this.bearing = v,
    'org.maplibre.compose.gljs.pitch_$external_prop_setter_1' : (_this, v) => _this.pitch = v,
    'org.maplibre.compose.gljs.setCoordinates_$external_fun' : (_this, p0) => _this.setCoordinates(p0),
    'org.maplibre.compose.gljs.updateImage_$external_fun' : (_this, p0) => _this.updateImage(p0),
    'org.maplibre.compose.gljs.setTiles_$external_fun' : (_this, p0) => _this.setTiles(p0),
    'org.maplibre.compose.gljs.type_$external_prop_getter_2' : (_this) => _this.type,
    'org.maplibre.compose.gljs.attribution_$external_prop_getter' : (_this) => _this.attribution,
    'org.maplibre.compose.gljs.url_$external_prop_setter_1' : (_this, v) => _this.url = v,
    'org.maplibre.compose.gljs.image_$external_prop_setter' : (_this, v) => _this.image = v,
    'org.maplibre.compose.gljs.setData_$external_fun' : (_this, p0) => _this.setData(p0),
    'org.maplibre.compose.gljs.fromGeojsonVt_$external_fun' : (p0, p1) => _ref_QG1hcGxpYnJlL3Z0LXBiZg_.fromGeojsonVt(p0, p1),
    'org.maplibre.compose.gljs.version_$external_prop_setter' : (_this, v) => _this.version = v,
    'org.maplibre.compose.gljs.extent_$external_prop_setter' : (_this, v) => _this.extent = v,
    'org.maplibre.compose.gljs.features_$external_prop_getter' : (_this) => _this.features,
    'org.maplibre.compose.gljs.geoJSONToTile_$external_fun' : (p0, p1, p2, p3, p4) => _ref_QG1hcGxpYnJlL2dlb2pzb24tdnQ_.geoJSONToTile(p0, p1, p2, p3, p4),
    'org.maplibre.compose.gljs.extent_$external_prop_setter_1' : (_this, v) => _this.extent = v,
    'org.maplibre.compose.gljs.buffer_$external_prop_setter' : (_this, v) => _this.buffer = v,
    'org.maplibre.compose.gljs.tolerance_$external_prop_setter' : (_this, v) => _this.tolerance = v,
    'org.maplibre.compose.gljs.maxZoom_$external_prop_setter_1' : (_this, v) => _this.maxZoom = v,
    'org.maplibre.compose.gljs.wrap_$external_prop_setter_1' : (_this, v) => _this.wrap = v,
    'org.maplibre.compose.gljs.clip_$external_prop_setter' : (_this, v) => _this.clip = v,
    'org.maplibre.compose.interaction.internal.measureBrowserLineHeight' : () => { const body = document.body; if (!body) return 16; const probe = document.createElement('div'); probe.style.fontSize = 'initial'; probe.style.display = 'none'; body.appendChild(probe); try { return parseFloat(window.getComputedStyle(probe).fontSize) || 16; } finally { body.removeChild(probe); } },
    'org.maplibre.compose.interaction.internal.wheelDeltaMode' : (event) => event == null || event.deltaMode == null ? null : event.deltaMode,
    'org.maplibre.compose.layers.floatArray' : (length) => new Float32Array(length),
    'org.maplibre.compose.layers.now' : () => performance.now(),
    'org.maplibre.compose.layers.glInt' : (gl, parameter) => gl.getParameter(parameter),
    'org.maplibre.compose.layers.glBoolean' : (gl, parameter) => gl.getParameter(parameter),
    'org.maplibre.compose.layers.viewportWidth' : (gl) => gl.getParameter(gl.VIEWPORT)[2],
    'org.maplibre.compose.layers.transparentPixel' : () => new Uint8Array([0,0,0,0]),
    'org.maplibre.compose.layers.setFloat' : (values, index, value) => { values[index] = value },
    'org.maplibre.compose.layers.createColorCanvas' : () => document.createElement('canvas'),
    'org.maplibre.compose.layers.cssColor' : (canvas, css) => { const ctx = canvas.getContext('2d'); ctx.clearRect(0,0,1,1); ctx.fillStyle = css; ctx.fillRect(0,0,1,1); const p = ctx.getImageData(0,0,1,1).data; const a = p[3]/255; return [p[0]/255*a,p[1]/255*a,p[2]/255*a,a]; },
    'org.maplibre.compose.layers.floatCopy' : (values) => new Float32Array(values),
    'org.maplibre.compose.layers.feedbackVaryings' : () => ['v_clip'],
    'org.maplibre.compose.layers.ACTIVE_TEXTURE_$external_prop_getter' : (_this) => _this.ACTIVE_TEXTURE,
    'org.maplibre.compose.layers.ARRAY_BUFFER_$external_prop_getter' : (_this) => _this.ARRAY_BUFFER,
    'org.maplibre.compose.layers.BLEND_$external_prop_getter' : (_this) => _this.BLEND,
    'org.maplibre.compose.layers.CLAMP_TO_EDGE_$external_prop_getter' : (_this) => _this.CLAMP_TO_EDGE,
    'org.maplibre.compose.layers.COMPILE_STATUS_$external_prop_getter' : (_this) => _this.COMPILE_STATUS,
    'org.maplibre.compose.layers.COPY_READ_BUFFER_$external_prop_getter' : (_this) => _this.COPY_READ_BUFFER,
    'org.maplibre.compose.layers.COPY_READ_BUFFER_BINDING_$external_prop_getter' : (_this) => _this.COPY_READ_BUFFER_BINDING,
    'org.maplibre.compose.layers.CULL_FACE_$external_prop_getter' : (_this) => _this.CULL_FACE,
    'org.maplibre.compose.layers.DEPTH_TEST_$external_prop_getter' : (_this) => _this.DEPTH_TEST,
    'org.maplibre.compose.layers.DYNAMIC_DRAW_$external_prop_getter' : (_this) => _this.DYNAMIC_DRAW,
    'org.maplibre.compose.layers.DYNAMIC_READ_$external_prop_getter' : (_this) => _this.DYNAMIC_READ,
    'org.maplibre.compose.layers.FLOAT_$external_prop_getter' : (_this) => _this.FLOAT,
    'org.maplibre.compose.layers.FRAGMENT_SHADER_$external_prop_getter' : (_this) => _this.FRAGMENT_SHADER,
    'org.maplibre.compose.layers.FUNC_ADD_$external_prop_getter' : (_this) => _this.FUNC_ADD,
    'org.maplibre.compose.layers.INTERLEAVED_ATTRIBS_$external_prop_getter' : (_this) => _this.INTERLEAVED_ATTRIBS,
    'org.maplibre.compose.layers.LINEAR_$external_prop_getter' : (_this) => _this.LINEAR,
    'org.maplibre.compose.layers.LINK_STATUS_$external_prop_getter' : (_this) => _this.LINK_STATUS,
    'org.maplibre.compose.layers.NEAREST_$external_prop_getter' : (_this) => _this.NEAREST,
    'org.maplibre.compose.layers.ONE_$external_prop_getter' : (_this) => _this.ONE,
    'org.maplibre.compose.layers.ONE_MINUS_SRC_ALPHA_$external_prop_getter' : (_this) => _this.ONE_MINUS_SRC_ALPHA,
    'org.maplibre.compose.layers.RGBA_$external_prop_getter' : (_this) => _this.RGBA,
    'org.maplibre.compose.layers.SAMPLER_BINDING_$external_prop_getter' : (_this) => _this.SAMPLER_BINDING,
    'org.maplibre.compose.layers.STENCIL_TEST_$external_prop_getter' : (_this) => _this.STENCIL_TEST,
    'org.maplibre.compose.layers.TEXTURE0_$external_prop_getter' : (_this) => _this.TEXTURE0,
    'org.maplibre.compose.layers.TEXTURE_2D_$external_prop_getter' : (_this) => _this.TEXTURE_2D,
    'org.maplibre.compose.layers.TEXTURE_BINDING_2D_$external_prop_getter' : (_this) => _this.TEXTURE_BINDING_2D,
    'org.maplibre.compose.layers.TEXTURE_MAG_FILTER_$external_prop_getter' : (_this) => _this.TEXTURE_MAG_FILTER,
    'org.maplibre.compose.layers.TEXTURE_MIN_FILTER_$external_prop_getter' : (_this) => _this.TEXTURE_MIN_FILTER,
    'org.maplibre.compose.layers.TEXTURE_WRAP_S_$external_prop_getter' : (_this) => _this.TEXTURE_WRAP_S,
    'org.maplibre.compose.layers.TEXTURE_WRAP_T_$external_prop_getter' : (_this) => _this.TEXTURE_WRAP_T,
    'org.maplibre.compose.layers.TRANSFORM_FEEDBACK_$external_prop_getter' : (_this) => _this.TRANSFORM_FEEDBACK,
    'org.maplibre.compose.layers.TRANSFORM_FEEDBACK_BINDING_$external_prop_getter' : (_this) => _this.TRANSFORM_FEEDBACK_BINDING,
    'org.maplibre.compose.layers.TRANSFORM_FEEDBACK_BUFFER_$external_prop_getter' : (_this) => _this.TRANSFORM_FEEDBACK_BUFFER,
    'org.maplibre.compose.layers.TRIANGLES_$external_prop_getter' : (_this) => _this.TRIANGLES,
    'org.maplibre.compose.layers.UNPACK_PREMULTIPLY_ALPHA_WEBGL_$external_prop_getter' : (_this) => _this.UNPACK_PREMULTIPLY_ALPHA_WEBGL,
    'org.maplibre.compose.layers.UNSIGNED_BYTE_$external_prop_getter' : (_this) => _this.UNSIGNED_BYTE,
    'org.maplibre.compose.layers.VERTEX_ARRAY_BINDING_$external_prop_getter' : (_this) => _this.VERTEX_ARRAY_BINDING,
    'org.maplibre.compose.layers.VERTEX_SHADER_$external_prop_getter' : (_this) => _this.VERTEX_SHADER,
    'org.maplibre.compose.layers.isContextLost_$external_fun' : (_this, ) => _this.isContextLost(),
    'org.maplibre.compose.layers.getParameter_$external_fun' : (_this, p0) => _this.getParameter(p0),
    'org.maplibre.compose.layers.createVertexArray_$external_fun' : (_this, ) => _this.createVertexArray(),
    'org.maplibre.compose.layers.createBuffer_$external_fun' : (_this, ) => _this.createBuffer(),
    'org.maplibre.compose.layers.createTransformFeedback_$external_fun' : (_this, ) => _this.createTransformFeedback(),
    'org.maplibre.compose.layers.createTexture_$external_fun' : (_this, ) => _this.createTexture(),
    'org.maplibre.compose.layers.createShader_$external_fun' : (_this, p0) => _this.createShader(p0),
    'org.maplibre.compose.layers.createProgram_$external_fun' : (_this, ) => _this.createProgram(),
    'org.maplibre.compose.layers.getUniformLocation_$external_fun' : (_this, p0, p1) => _this.getUniformLocation(p0, p1),
    'org.maplibre.compose.layers.deleteProgram_$external_fun' : (_this, p0) => _this.deleteProgram(p0),
    'org.maplibre.compose.layers.deleteTexture_$external_fun' : (_this, p0) => _this.deleteTexture(p0),
    'org.maplibre.compose.layers.deleteBuffer_$external_fun' : (_this, p0) => _this.deleteBuffer(p0),
    'org.maplibre.compose.layers.deleteTransformFeedback_$external_fun' : (_this, p0) => _this.deleteTransformFeedback(p0),
    'org.maplibre.compose.layers.deleteVertexArray_$external_fun' : (_this, p0) => _this.deleteVertexArray(p0),
    'org.maplibre.compose.layers.deleteShader_$external_fun' : (_this, p0) => _this.deleteShader(p0),
    'org.maplibre.compose.layers.bindVertexArray_$external_fun' : (_this, p0) => _this.bindVertexArray(p0),
    'org.maplibre.compose.layers.useProgram_$external_fun' : (_this, p0) => _this.useProgram(p0),
    'org.maplibre.compose.layers.enableVertexAttribArray_$external_fun' : (_this, p0) => _this.enableVertexAttribArray(p0),
    'org.maplibre.compose.layers.disable_$external_fun' : (_this, p0) => _this.disable(p0),
    'org.maplibre.compose.layers.enable_$external_fun' : (_this, p0) => _this.enable(p0),
    'org.maplibre.compose.layers.blendEquation_$external_fun' : (_this, p0) => _this.blendEquation(p0),
    'org.maplibre.compose.layers.blendFunc_$external_fun' : (_this, p0, p1) => _this.blendFunc(p0, p1),
    'org.maplibre.compose.layers.bindSampler_$external_fun' : (_this, p0, p1) => _this.bindSampler(p0, p1),
    'org.maplibre.compose.layers.activeTexture_$external_fun' : (_this, p0) => _this.activeTexture(p0),
    'org.maplibre.compose.layers.bindTexture_$external_fun' : (_this, p0, p1) => _this.bindTexture(p0, p1),
    'org.maplibre.compose.layers.pixelStorei_$external_fun' : (_this, p0, p1) => _this.pixelStorei(p0, p1),
    'org.maplibre.compose.layers.bindTransformFeedback_$external_fun' : (_this, p0, p1) => _this.bindTransformFeedback(p0, p1),
    'org.maplibre.compose.layers.bindBuffer_$external_fun' : (_this, p0, p1) => _this.bindBuffer(p0, p1),
    'org.maplibre.compose.layers.bindBufferRange_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.bindBufferRange(p0, p1, p2, p3, p4),
    'org.maplibre.compose.layers.bindBufferBase_$external_fun' : (_this, p0, p1, p2) => _this.bindBufferBase(p0, p1, p2),
    'org.maplibre.compose.layers.beginTransformFeedback_$external_fun' : (_this, p0) => _this.beginTransformFeedback(p0),
    'org.maplibre.compose.layers.endTransformFeedback_$external_fun' : (_this, ) => _this.endTransformFeedback(),
    'org.maplibre.compose.layers.bufferData_$external_fun' : (_this, p0, p1, p2) => _this.bufferData(p0, p1, p2),
    'org.maplibre.compose.layers.bufferData_$external_fun_1' : (_this, p0, p1, p2) => _this.bufferData(p0, p1, p2),
    'org.maplibre.compose.layers.getBufferSubData_$external_fun' : (_this, p0, p1, p2) => _this.getBufferSubData(p0, p1, p2),
    'org.maplibre.compose.layers.vertexAttribPointer_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.vertexAttribPointer(p0, p1, p2, p3, p4, p5),
    'org.maplibre.compose.layers.drawArrays_$external_fun' : (_this, p0, p1, p2) => _this.drawArrays(p0, p1, p2),
    'org.maplibre.compose.layers.texImage2D_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6, p7, p8) => _this.texImage2D(p0, p1, p2, p3, p4, p5, p6, p7, p8),
    'org.maplibre.compose.layers.texParameteri_$external_fun' : (_this, p0, p1, p2) => _this.texParameteri(p0, p1, p2),
    'org.maplibre.compose.layers.uniform1i_$external_fun' : (_this, p0, p1) => _this.uniform1i(p0, p1),
    'org.maplibre.compose.layers.uniform1f_$external_fun' : (_this, p0, p1) => _this.uniform1f(p0, p1),
    'org.maplibre.compose.layers.uniform3f_$external_fun' : (_this, p0, p1, p2, p3) => _this.uniform3f(p0, p1, p2, p3),
    'org.maplibre.compose.layers.uniform4f_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.uniform4f(p0, p1, p2, p3, p4),
    'org.maplibre.compose.layers.uniform4fv_$external_fun' : (_this, p0, p1) => _this.uniform4fv(p0, p1),
    'org.maplibre.compose.layers.uniformMatrix4fv_$external_fun' : (_this, p0, p1, p2) => _this.uniformMatrix4fv(p0, p1, p2),
    'org.maplibre.compose.layers.shaderSource_$external_fun' : (_this, p0, p1) => _this.shaderSource(p0, p1),
    'org.maplibre.compose.layers.compileShader_$external_fun' : (_this, p0) => _this.compileShader(p0),
    'org.maplibre.compose.layers.getShaderParameter_$external_fun' : (_this, p0, p1) => _this.getShaderParameter(p0, p1),
    'org.maplibre.compose.layers.getShaderInfoLog_$external_fun' : (_this, p0) => _this.getShaderInfoLog(p0),
    'org.maplibre.compose.layers.attachShader_$external_fun' : (_this, p0, p1) => _this.attachShader(p0, p1),
    'org.maplibre.compose.layers.transformFeedbackVaryings_$external_fun' : (_this, p0, p1, p2) => _this.transformFeedbackVaryings(p0, p1, p2),
    'org.maplibre.compose.layers.linkProgram_$external_fun' : (_this, p0) => _this.linkProgram(p0),
    'org.maplibre.compose.layers.getProgramParameter_$external_fun' : (_this, p0, p1) => _this.getProgramParameter(p0, p1),
    'org.maplibre.compose.layers.getProgramInfoLog_$external_fun' : (_this, p0) => _this.getProgramInfoLog(p0),
    'org.maplibre.compose.layers.clipFloatAt' : (values, index) => values[index],
    'org.maplibre.compose.layers.paintSpecification' : (color) => ({type: color ? 'color' : 'number', default: color ? 'white' : 0, 'property-type': 'data-constant', expression: {interpolated: true, parameters: ['zoom']}}),
    'org.maplibre.compose.layers.expressionResult' : (result) => result.result,
    'org.maplibre.compose.layers.evaluatePaint' : (expression, zoom, globalState) => expression.evaluate({zoom, globalState}),
    'org.maplibre.compose.layers.paintComponent' : (value, name) => value[name],
    'org.maplibre.compose.logging.logToConsole' : (level, line, stack) => { const method = level === 'warning' ? 'warn' : level === 'debug' ? 'log' : level; if (stack == null) console[method](line); else console[method](line, stack); },
    'org.maplibre.compose.map.snapshotRgba' : (output, source, width, height, transparent) => { const context = output.getContext('2d'); if (!context) throw new Error('The browser would not give a 2D snapshot context'); if (!transparent) {context.fillStyle = '#ffffff'; context.fillRect(0,0,width,height);} context.drawImage(source,0,0,width,height); return context.getImageData(0,0,width,height).data; },
    'org.maplibre.compose.map.snapshotByte' : (data, index) => data[index],
    'org.maplibre.compose.map.removeBodyListener' : (listener) => { document.removeEventListener('DOMContentLoaded', listener) },
    'org.maplibre.compose.map.addBodyListener' : (listener) => { document.addEventListener('DOMContentLoaded', listener) },
    'org.maplibre.compose.map.browserBody' : () => document.body,
    'org.maplibre.compose.resource.undefined_js_code' : () => (undefined),
    'org.maplibre.compose.resource.protocolError' : (message, status, url) => { const error = new Error(message); error.status = status; error.url = url; return error; },
    'org.maplibre.compose.resource.unwrapProtocolResult' : (promise) => promise.then(value => { if (value instanceof Error) throw value; return value; }),
    'org.maplibre.compose.resource.randomize' : (bytes) => { crypto.getRandomValues(bytes) },
    'org.maplibre.compose.resource.byteAt' : (bytes, index) => bytes[index],
    'org.maplibre.compose.resource.setHeader' : (headers, name, value) => { headers[name] = value },
    'org.maplibre.compose.style.emptyLayers' : () => Object.create(null),
    'org.maplibre.compose.style.encodedByteAt' : (bytes, index) => bytes[index],
    'org.maplibre.compose.style.unwrapTileResult' : (promise) => promise.then(value => { if (value instanceof Error) throw value; return value; }),
    'org.maplibre.compose.util.numberFormatOptions' : (digits) => ({ maximumFractionDigits: digits }),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.navigation.compose.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.navigation.compose.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.loadBuffer' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:buffer') : null),
    'kotlinx.io.node.loadOs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:os') : null),
    'kotlinx.io.node.loadPath' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:path') : null),
    'kotlinx.io.node.loadFs' : ((module) => () => module)(((typeof process !== 'undefined') && (process.release.name === 'node')) ? await import(/* webpackIgnore: true */'node:fs') : null),
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'org.maplibre.compose.demoapp.JsJodaTimeZoneModule_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvdGltZXpvbmU_,
    'org.maplibre.compose.demoapp.benchmark.benchmarkQuery' : () => new URLSearchParams(window.location.search).get('benchmark'),
    'org.maplibre.compose.demoapp.benchmark.requestRepaint' : (map) => { map.triggerRepaint() },
    'org.maplibre.compose.demoapp.demos.snapshotter.encodeCanvas' : (canvas, rgba) => { const ctx = canvas.getContext('2d'); if (!ctx) throw new Error('The browser would not give a 2D context'); ctx.putImageData(new ImageData(new Uint8ClampedArray(rgba.buffer),canvas.width,canvas.height),0,0); return canvas.toDataURL('image/png'); },
    'org.maplibre.compose.demoapp.demos.snapshotter.setByte' : (bytes, index, value) => { bytes[index] = value },
    'org.maplibre.compose.demoapp.demos.snapshotter.hasWebShare' : () => typeof navigator.share === 'function' && typeof navigator.canShare === 'function',
    'org.maplibre.compose.demoapp.demos.snapshotter.shareSnapshot' : (data) => navigator.share(data).then(() => 'completed', error => error.name === 'AbortError' ? 'cancelled' : 'failed'),
    'org.maplibre.compose.demoapp.demos.snapshotter.asKotlinString' : (value) => value,
    'org.maplibre.compose.demoapp.launchParameter' : (name) => new URLSearchParams(window.location.search).get(name),
    'org.maplibre.compose.demoapp.util.message_$external_prop_getter' : (_this) => _this.message,
    'org.maplibre.compose.demoapp.util.unzip_$external_fun' : (p0, p1) => _ref_ZmZsYXRl_.unzip(p0, p1),
    'org.maplibre.compose.demoapp.util.objectKeys' : (value) => Object.keys(value),
    'org.maplibre.compose.demoapp.util.jsStringToKotlin' : (value) => value,
    'org.maplibre.compose.demoapp.util.jsGet' : (value, name) => value[name],
    'org.maplibre.compose.demoapp.util.jsUnsafeCast' : (value) => value,
    'org.maplibre.compose.demoapp.util.setUint8At' : (target, index, value) => { target[index] = value },
    'org.maplibre.compose.demoapp.util.getUint8At' : (target, index) => target[index]
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    